import AdminAddPasein from "../../components/AdminModules/AdminModulesAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
